import { Injectable } from '@angular/core';

export type ToasterType = 'success' | 'error' | 'warning' | 'info';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private duration = 3000;
  private toasterConfig = {
    closeButton: false,
    timeOut: this.duration,
  };
  constructor() { }
  async presentToast(message, title?, type?: ToasterType) {
    const x = document.getElementById('snackbar');
    x.className = '';

    setTimeout(() => {
      x.className = 'show';
      x.innerHTML = message;

      setTimeout(() => {
        x.className = x.className.replace('show', '');
      }, 3000)
    }, 200)
    // this.toasterService[type](message, '', this.toasterConfig);
  }
}
